import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: 'designGuide',
components: {
XTable,
},
data () {
return {
maxHeight: (document.body.clientHeight - 140)+'px'
}
},
methods: {
renderResize() {
this.getTableDatas()
this.$nextTick(function(){
this.$refs.right.style.width=""+this.$refs.table.offsetWidth-105+"px";
this.$refs.right2.style.width=""+this.$refs.table2.offsetWidth-105+"px";
})
},
tableDivScroll (event) {
const $target = this.$refs.tableContainer
const $target2 = this.$refs.tableContainer2

this.$refs.firstRowLayer.scrollLeft = $target.scrollLeft

this.$refs.firstColLayer.scrollTop = $target.scrollTop


this.$refs.firstRowLayer2.scrollLeft = $target2.scrollLeft

this.$refs.firstColLayer2.scrollTop = $target2.scrollTop
},
},
created () {

},
mounted() {
this.$nextTick(function(){
this.$refs.right.style.width=""+this.$refs.table.offsetWidth-105+"px";
this.$refs.right2.style.width=""+this.$refs.table2.offsetWidth-105+"px";
})

},
}



// WEBPACK FOOTER //
// ./src/views/designGuide/script.js